<template>
  <div class="covs">
    <div class="container">
      <h1>VOCs综合管控</h1>
      <p class="subtitle">全方位的环境监测与管理解决方案</p>
      
      <div class="covs-section">
        <h2 class="section-title">VOCs在线监测</h2>
        <div class="service-list">
          <router-link to="/covs/online-1" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/9.jpg')" alt="固定源挥发性有机物（VOCs）在线监测系统" />
            </div>
            <div class="service-content">
              <h3>固定源挥发性有机物（VOCs）在线监测系统</h3>
            </div>
          </router-link>
          <router-link to="/covs/online-2" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/10.jpg')" alt="VOCs排放在线监测系统" />
            </div>
            <div class="service-content">
              <h3>VOCs排放在线监测系统（固定源、厂界/园区 VOCs 在线监测系统）</h3>
            </div>
          </router-link>
        </div>
      </div>

      <div class="covs-section">
        <h2 class="section-title">政府/园区级VOCs综合管控</h2>
        <div class="service-list">
          <router-link to="/covs/gov-1" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/13.png')" alt="政府/园区级VOCs综合管控服务" />
            </div>
            <div class="service-content">
              <h3>政府/园区级VOCs综合管控服务</h3>
            </div>
          </router-link>
        </div>
      </div>

      <div class="covs-section">
        <h2 class="section-title">集团/企业级VOCs综合管控服务</h2>
        <div class="service-list">
          <router-link to="/covs/enterprise-1" class="service-item">
            <div class="service-image">
              <img :src="require('../assets/14.png')" alt="集团/企业级VOCs综合管控" />
            </div>
            <div class="service-content">
              <h3>集团/企业级VOCs综合管控</h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCovs'
}
</script>

<style scoped>
.covs {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 60px;
}

@media screen and (max-width: 768px) {
  .covs {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .covs {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

.covs-section {
  margin-bottom: 80px;
}

.section-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #42b983;
}

@media screen and (max-width: 768px) {
  .covs-section {
    margin-bottom: 60px;
  }

  .section-title {
    font-size: 24px;
  }
}

@media screen and (max-width: 480px) {
  .covs-section {
    margin-bottom: 40px;
  }

  .section-title {
    font-size: 20px;
  }
}

.service-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-item {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
  display: block;
  text-decoration: none;
  color: inherit;
}

.service-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  background-color: #e6f3ee;
}

.service-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-item:hover .service-image img {
  transform: scale(1.1);
}

.service-content {
  padding: 25px;
}

.service-content h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 12px;
}

.service-content p {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .service-list {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .service-image {
    height: 180px;
  }

  .service-content {
    padding: 20px;
  }

  .service-content h3 {
    font-size: 18px;
  }

  .service-content p {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .service-list {
    grid-template-columns: 1fr;
  }

  .service-image {
    height: 160px;
  }

  .service-content {
    padding: 15px;
  }

  .service-content h3 {
    font-size: 16px;
  }

  .service-content p {
    font-size: 13px;
  }
}
</style>